var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.53 12.47C13.823 12.763 13.823 13.238 13.53 13.531C13.384 13.677 13.192 13.751 13 13.751C12.808 13.751 12.616 13.678 12.47 13.531L6.99999 8.061L1.52999 13.531C1.38399 13.677 1.19199 13.751 0.999993 13.751C0.807993 13.751 0.615994 13.678 0.469994 13.531C0.176994 13.238 0.176994 12.763 0.469994 12.47L5.94 7.00002L0.469994 1.53005C0.176994 1.23705 0.176994 0.762018 0.469994 0.469018C0.762994 0.176018 1.238 0.176018 1.531 0.469018L7.001 5.93905L12.471 0.469018C12.764 0.176018 13.239 0.176018 13.532 0.469018C13.825 0.762018 13.825 1.23705 13.532 1.53005L8.06199 7.00002L13.53 12.47Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/times.ebe9acdf54cb9ebf768c55b681dd3126.svg";